import { classNames } from "~/utils";
import iconMedia from "~/assets/icons/icon-media.svg";
import iconFachbeitraege from "~/assets/icons/icon-fachbeitraege.svg";
import iconEvent from "~/assets/icons/icon-event.svg";

interface LandingPageTabsProps {
  activeTab: "medien" | "fachartikel" | "veranstaltungen";
  setActiveTab: (tab: "medien" | "fachartikel" | "veranstaltungen") => void;
  isMobile?: boolean;
}

export const LandingPageTabs: React.FC<LandingPageTabsProps> = ({
  activeTab,
  setActiveTab,
  isMobile = false,
}) => {
  const buttonBaseClass = isMobile
    ? "inline-flex flex-1 items-center justify-center px-2 py-2 text-xs font-medium"
    : "inline-flex items-center px-6 py-3 text-sm font-medium ";

  const iconSizeClass = isMobile ? "mr-1 h-3 w-3" : "mr-2 h-5 w-5";
  const getIconClass = (tab: "medien" | "fachartikel" | "veranstaltungen") =>
    classNames(iconSizeClass, activeTab === tab ? "" : "brightness-0 invert");

  return (
    <div className="flex gap-0">
      <button
        onClick={() => setActiveTab("medien")}
        style={{ borderTopLeftRadius: "20px" }}
        className={classNames(
          buttonBaseClass,
          "border-b-0",
          activeTab === "medien"
            ? "bg-white text-primary"
            : "bg-primary text-white hover:bg-primary"
        )}
      >
        <img
          src={iconMedia}
          alt=""
          aria-hidden="true"
          className={getIconClass("medien")}
        />
        Medien
      </button>

      <button
        onClick={() => setActiveTab("fachartikel")}
        className={classNames(
          buttonBaseClass,
          "border-b-0",
          activeTab === "fachartikel"
            ? "bg-white text-primary"
            : "bg-primary text-white hover:bg-primary"
        )}
      >
        <img
          src={iconFachbeitraege}
          alt=""
          aria-hidden="true"
          className={getIconClass("fachartikel")}
        />
        Fachbeiträge
      </button>

      <button
        onClick={() => {
          window.open("https://veranstaltungen.ru-digital.de", "_blank");
        }}
        style={{ borderTopRightRadius: "20px" }}
        className={classNames(
          buttonBaseClass,
          "border-b-0",
          "bg-primary text-white hover:bg-primary"
        )}
      >
        <img
          src={iconEvent}
          alt=""
          aria-hidden="true"
          className={getIconClass("veranstaltungen")}
        />
        Veranstaltungen
      </button>
    </div>
  );
};
